import { DevisClient } from "modules/devis/types/devis.interface";

export enum ReductionType {
  PERCENTAGE = "percentage",
  AMOUNT = "amount",
}

export enum INVOICE_STATUS {
  DRAFT = "draft",
  VALIDATED = "validated",
  SENT = "sent",
  PAID = "paid",
}

export enum PAYMENT_METHOD {
  BANK_TRANSFER = "bank_transfer",
  CREDIT_CARD = "credit_card",
  CHECK = "check",
  CASH = "cash",
  OTHER = "other",
}

export interface InvoiceLineItem {
  articleId?: string;
  description: string;
  quantity: number;
  unitPriceHT?: number;
  reductionType?: ReductionType;
  reductionAmount?: number;
  vatAmount?: number;
  totalTTC: number;
  totalHT: number;
  priceHT?: number;
}

export interface InvoiceTransaction {
  _id?: string;
  amount: number;
  paymentDate: Date;
  paymentMethod: PAYMENT_METHOD;
  reference?: string;
  notes?: string;
  createdAt?: Date;
  createdBy?: string;
}

export interface StatisticMonthlyBreakdown {
  month: number;
  paid: number;
  onHold: number;
  late: number;
}

export interface StatisticPercentages {
  paid: number;
  onHold: number;
  late: number;
}

export interface Statistic {
  totalInvoiced: number;
  totalPaid: number;
  totalOnHold: number;
  totalLate: number;
  percentages: StatisticPercentages;
  percentageChanges: StatisticPercentages;
  countChanges: StatisticPercentages;
  monthlyBreakdown: StatisticMonthlyBreakdown[];
}

export interface DocumentSummary {
  totalHT: number;
  totalRemise: number;
  totalHTFinal: number;
  totalVAT: number;
  totalTTC: number;
  vatPercentage: number;
}

export interface Invoice {
  _id: string;
  summary?: DocumentSummary;
  totalTTC: number;
  totalHT: number;
  dueDate: Date;
  createdAt: Date;
  updatedAt: Date;
  status: INVOICE_STATUS;
  archived: boolean;
  lineItems: InvoiceLineItem[];
  clientId: string;
  client: DevisClient;
  ebpId?: string;
  lastContact?: Date;
  workspaceId: string;
  interveners?: string[];
  devisId?: string;
  documentNumber: {
    number: string;
    prefix: string;
    suffix: string;
  };
  transactions?: InvoiceTransaction[];
  dueAmount?: number;
}

export interface CreateInvoicePayload {
  _id?: string;
  totalTTC: number;
  totalHT: number;
  lineItems: InvoiceLineItem[];
  clientId: string;
  ebpId?: string;
  status?: INVOICE_STATUS;
  archived?: boolean;
  interveners?: string[];
  dueDate: Date;
  articleId?: string;
  reductionType?: ReductionType;
  reductionAmount?: number;
  devisId?: string;
  documentNumber?: any;
  devisDocumentNumber?: string;
  lastContact?: Date;
  transactions?: InvoiceTransaction[];
}
